import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * The patient app's entry point is the booking funnel. The marketing site's "Book"
 * buttons point at `/book` (REQUIREMENTS §17), so `/` only has to get out of the way.
 * TODO(M10.x): the patient portal takes this route once sign-in exists.
 */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/book' });
  },
});
